import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from '@commoncore/services/global.service';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';

@Component({
  selector: 'common-user-communication',
  templateUrl: './user-communication.component.html',
  styleUrl: './user-communication.component.scss',
})
export class UserCommunicationComponent {

  public router: Router;
  public universalService: any;
  localStorageSvc: any;
  userData: any;

  constructor(public globalService: GlobalService) {
    this.setEnvObjects();
  }

  setEnvObjects() {
    this.router = this.globalService.getRouterRef();
    this.universalService = this.globalService.getUniversalServiceRef();
    this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
  }

  ngOnInit() {
    this.userData = this.localStorageSvc.getUserData(true);
  }

  goToExport(){
    this.router.navigate(['/dataexport']);
  }
  goToDownloadApp(){
    let url = "";
    if(this.universalService.isMobileDevice){
      url = 'https://jiocloud.page.link/experienceJioCloud'
    }else{
      url = window.location.protocol + "//" + window.location.host + "/downloadApp";  
    }
    window.open(url ,'_blank', "noopener, noreferrer");  
  }
}
